// Signal-color lookup for /servicios. Full class-name strings are written
// out literally (never templated as `bg-${color}`) so Tailwind's content
// scanner can find and keep them in the production build.
export const CHAPTER_THEME = {
  orange: {
    text: "text-signalOrange",
    bg: "bg-signalOrange",
    border: "border-signalOrange",
    ring: "ring-signalOrange",
    hoverBorder: "hover:border-signalOrange/60",
    glow: "bg-signalOrange/25",
  },
  cobalt: {
    text: "text-signalCobalt",
    bg: "bg-signalCobalt",
    border: "border-signalCobalt",
    ring: "ring-signalCobalt",
    hoverBorder: "hover:border-signalCobalt/60",
    glow: "bg-signalCobalt/25",
  },
  lime: {
    text: "text-signalLime",
    bg: "bg-signalLime",
    border: "border-signalLime",
    ring: "ring-signalLime",
    hoverBorder: "hover:border-signalLime/60",
    glow: "bg-signalLime/25",
  },
};

// Deep/darkened solid tone per chapter color — used as a full-bleed card
// background (e.g. the market StatCube cards), where the bright signal hue
// itself would be too loud at that scale. Kept as literal hex (not a
// Tailwind class) since it's applied via inline style, not a utility class.
export const CHAPTER_DEEP = {
  orange: "#7A2E1E",
  cobalt: "#1D2266",
  lime: "#3C5A0E",
};
